import { Fragment, h } from 'preact';
import { useEffect } from 'preact/hooks';
import { ZAPPING_NAME } from '../../../common/components/panel/constants';
import Scrollable from '../../../common/hoc/scrollable';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import { getList } from '../../../common/utils/list';
import { usePanelCloseCallback } from '../wrappers/Zap/PanelLiveOption';
import Program from './Program';

function Programs() {
  const player = usePlayerContext();
  const { panelLiveOption: { currentTab } } = useNewStore('ui', player);
  const { imagesHL } = useNewStore('highlights', player);
  const { recommendations } = useNewStore('recommendations', player);
  const {
    list: zappingList,
    current: { tabIndex: activeTabIndex, activeChannel, activeChannelId }
  } = useNewStore('zapping', player);
  const { id } = useNewStore('media', player);
  const { playlist } = useNewStore('playlist', player);

  const activeTab = currentTab === ZAPPING_NAME ? activeTabIndex : 0;
  const list = getList({ currentTab, list: zappingList, playlist, recommendations, imagesHL });
  const { channels = [] } = list[activeTab] || {};

  const close = usePanelCloseCallback();

  useEffect(
    () => (!channels.length && !!currentTab && close(currentTab)),
    [channels.length]
  );

  return (
    <Scrollable forceInnerScroll>
      <Fragment>
        {channels.map((metadata, i) => (
          <Program
            metadata={metadata}
            active={[activeChannelId, id].includes(metadata.id)}
            activeTabMetadata={channels[activeChannel] || null}
            currentTab={currentTab}
            programNumber={i}
            channels={channels}
          />
        ))}
      </Fragment>
    </Scrollable>
  );
}

export default Programs;
